import excelStyle from './styles/excel';
import * as xlsx from 'xlsx-js-style';
import { MARKER } from 'utils/styles/images.jsx'
import dayjs from 'dayjs';

/**
 * @details 유효성 검사  
 * @author ws
 * @version 1.0 
 * @Date 23.11.09
 * @param String e  
 * @return boolean
*/

export const V_CHECK = { 
    IP : function ( e )      { return ( !/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(e) === true ); },
    HP : function ( e )      { return ( !/^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/.test(e) === true); },
    TELE : function ( e )      { return ( !/^0([0-9]{1,2})-?([0-9]{3,4})-?([0-9]{4})$/.test(e) === true); },
    PORT  : function ( e )   { return ( !/^(6553[0-5]|655[0-2]\d|65[0-4]\d{2}|6[0-4]\d{3}|[1-5]\d{4}|[1-9]\d{0,3})$/.test(e) === true); },
    EMAIL : function ( e )   { return ( /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i.test(e) === true); },
    NUMBER : function ( e )  { return ( /^[0-9]+$/.test(e) === true ); },
    YYYYMM : function ( e )  { return ( /(^\d{4})-(0[1-9]|1[0-2])$/.test(e) === true); },
    YYYYMMDD : function ( e ){ return ( /(^\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/.test(e) === true); },
    KO : function ( e )  { return ( /[ㄱ-ㅎㅏ-ㅣ가-힣]/.test(e) === true ); },
    ID : function ( e )  { return ( /^[a-z][a-z0-9_]{4,20}$/.test(e) === false ); },
}

/**
 * @details 기간 string to dayJs
 * @author lhy
 * @version 1.0 
 * @Date 24.01.23
 * @param string, string
 * @result array [dayjs, dayjs]
 */

export const getPeriod = (sDate, eDate) => {
  if (sDate === "2024-01-01" && eDate === "") {
    return[dayjs("2024-01-01 00:00:00", "YYYY/MM/DD HH:mm:ss"), ""];
  }
  if (sDate === "" || !V_CHECK.YYYYMMDD(sDate) || !V_CHECK.YYYYMMDD(eDate)) return ["", ""];
  sDate = sDate + " 00:00:00";
  eDate = eDate +  " 00:00:00";
  return [dayjs(sDate, "YYYY-MM-DD HH:mm:ss"), dayjs(eDate, "YYYY-MM-DD HH:mm:ss")]
}

/**
 * @details DatePicker 결과 내보내기
 * @author lhy
 * @version 1.0 
 * @Date 24.01.24
 * @param evt, func, func
 */

export const setPeriod = (e, setSdate, setEdate) => {
  if (e !== null) {
    setSdate(`${e[0]["$y"]}-${String(e[0]["$M"]+1).padStart(2, "0")}-${String(e[0]["$D"]).padStart(2, "0")}`);
    setEdate(`${e[1]["$y"]}-${String(e[1]["$M"]+1).padStart(2, "0")}-${String(e[1]["$D"]).padStart(2, "0")}`);
  } else {
    setSdate("");
    setEdate("");
  }
}

/**
 * @details api 결과 alert 
 * @author lhy
 * @version 1.0 
 * @Date 23.12.11
 * @param object res 
 * 
*/
export const resultAlert = (res) => {
    if (!res.error || res === true) {
        alert("완료되었습니다.");
    } else {
        alert("관리자에게 문의해주세요.");
    }
    
}

/**
 * @details api 결과 error 일때 , 빈배열 반환 
 * @author lhy
 * @version 1.0 
 * @Date 24.01.10
 * @param object res 
 * @return array
 * 
*/
export const resultArray = (res) => {
  return res.data.error ? [] : res.data
}

/**
 * @details api 결과 error 일때 , 0 반환 
 * @author lhy
 * @version 1.0 
 * @Date 24.01.16
 * @param object res
 * @return int
 * 
*/
export const resultNumber = (res) => {
  return res.data.error ? 0 : res.data
}


/**
 * @details 엑셀 저장 
 * @author lhy
 * @version 1.0 
 * @Date 23.12.28
 * @param object res 
 * 
*/
export const getMngExcel = (fileName, title, headers=[], rows=[], colWidth=[]) => {
    const excel = xlsx.utils.book_new();
    let today = new Date();   
    let date = `${today.getFullYear()}${today.getMonth()+1}${today.getDate()}`;
    let header =[[{v:title ,s:{alignment:{horizontal:"center"}, font:{sz:24}, border:excelStyle.borderThick}}],[],
      ["파일 생성일", "", `${String(today.getFullYear()).padStart(2, "0")}-${String(today.getMonth()+1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")} ${String(today.getHours()).padStart(2, "0")}:${String(today.getMinutes()).padStart(2, "0")}`],[""],];
    let tmp=[headers];
    let body = [];
    let whole = [];
    let len = headers.length;
    let idx = rows.length;
    
    for (let i =0; i<len; i++){
      i && header[0].push({v:"", s:{border:excelStyle.borderThick}});
      header[1].push({v:"", s:{border:excelStyle.borderThick}});
    }
    
    for (let row of rows) {
      tmp.push( Object.values(row));
    }

    for (let i=0; i<idx+1; i++){
      let body_s=[];
      for (let j=0; j<len; j++){
        body_s.push({v:tmp[i][j] ? tmp[i][j]: "", s:{border : excelStyle.borderThin}});
      }
      body.push(body_s);
    }

    whole = [...header, ...body];
    const data = xlsx.utils.aoa_to_sheet( whole, { header : [], skipHeader : true } );
    data['!merges'] = [{s: {c: 0, r:0}, e: { c:len-1, r:1 } },{s: {c: 0, r:2}, e: { c:1, r:2 } }, {s: {c: 2, r:2}, e: { c:len-1, r:2 } },];
    data["!cols"] = colWidth;

    xlsx.utils.book_append_sheet( excel, data, "SHEET 1" );
    xlsx.writeFile( excel, `${fileName}_${date}.xlsx` ); 
    
}

/**
 * @details 장비 상태별 마커 이미지 반환 
 * @author lhy
 * @version 1.0 
 * @Date 24.01.17
 * @param int dev_status 
 * @return String src
*/
export const getMarker = (dev_status ) => {
  return dev_status === 0 ? MARKER.NORMAL : dev_status === 1 ? MARKER.EVT : MARKER.ERROR;
}
